import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=7213f56b"
import script from "./Buy.vue?vue&type=script&setup=true&lang=ts"
export * from "./Buy.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports